import { Box, Button, Card, CardContent } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { AdminPanelSettings, PostAdd } from '@mui/icons-material'
import { useEffect } from 'react'
import { logEvent } from 'firebase/analytics'
import AdminHelpPulse from './AdminHelpPulse'

const AdminHelp = ({ analytics }) => {
  const navigate = useNavigate()
  useEffect(() => {
    logEvent(analytics, 'admin_help')
  }, [])
  return (
    <Card
      raised
      sx={{
        margin: { md: 2, xs: 1 },
        marginTop: { xs: 2 }
      }}
    >
      <CardContent sx={{ maxWidth: '1200px', m: 'auto', p: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center'
          }}
        >
          <AdminPanelSettings />
          <h2>Admin Upload Help</h2>
        </Box>
        <a href='#uploadPulse'>
          <Button variant='outlined'>How to Upload a Pulse</Button>
        </a>
        <Card raised sx={{ mt: 2, mb: 1 }}>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: 'primary.main'
              }}
            >
              <PostAdd /> <h3>Upload a Document</h3>
            </Box>
            <b>Document Information</b>
            <br />
            Required:
            <ul>
              <li>File Name,</li> <li>Organization Name</li>
            </ul>
            Optional:
            <ul>
              <li>Logo,</li> <li>Host Name,</li> <li>Description,</li>{' '}
              <li>Contact Information,</li>{' '}
              <li>Contact Link (must be a valid url)</li>
            </ul>
            <br />
            <b>Document File is Required</b>
            <br />
            <br />
            <b>Document Configuration</b>
            <br />
            Required:{' '}
            <ul>
              <li>Visible Dates (dates any user can see the document)</li>
            </ul>
            Optional:{' '}
            <ul>
              <li>
                Admin Emails (share admin permissions with other users, they
                must sign up with the inputted email),
              </li>{' '}
              <li>Allow Comments (dates must be between Visible Dates),</li>
              <li>
                Comment Visibility (allow users to see all comments or only
                their own),
              </li>
              <li>Access Code (add a password to the document),</li>
              <li>
                Searchable by public (allow document to be found on search tab),
              </li>
              <li>Require sign in to view</li>
            </ul>
            <iframe
              width='560'
              height='315'
              src='https://www.youtube.com/embed/zcH7Zx-t2b8?si=Qk6GBI3BzKwqsU1Z'
              title='YouTube video player'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              referrerPolicy='strict-origin-when-cross-origin'
              allowFullScreen
              style={{ width: '100%', border: '0' }}
            ></iframe>
          </CardContent>
        </Card>
        <a id='uploadPulse'></a>
        <Card raised sx={{ mt: 2, mb: 1 }}>
          <CardContent>
            <AdminHelpPulse />
          </CardContent>
        </Card>
        <Button
          onClick={() => navigate('/signupadmin')}
          variant='contained'
          sx={{ mt: 1, mr: 2 }}
        >
          Admin Sign Up
        </Button>
        <Button
          onClick={() => navigate('/support/contact')}
          variant='contained'
          sx={{ mt: 1 }}
        >
          Contact Us
        </Button>
      </CardContent>
    </Card>
  )
}

export default AdminHelp
